import { imageApi } from '../api';

import type { IImageCreate, IImageUpdate } from './types';

export const useImageStore = () => {
  const { create: createImage, update: updateImage, remove: removeImage } = imageApi();

  const create = async (image: IImageCreate) => {
    const { data } = await createImage(image);

    return data;
  };

  const update = async (image: IImageUpdate) => {
    return (await updateImage(image)).data;
  };

  const remove = async (id: string) => {
    return removeImage(id);
  };

  return { create, update, remove };
};
